import React from "react";
import { InputComponentRequirementDialogInitialState, PageNewState } from ".";

export const InputComponentRequirementDialogContext = React.createContext({
  pageState: InputComponentRequirementDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
